import React, {useState,useEffect} from 'react';


function checkContacts(){
    if('contacts' in navigator){
        return "support"
    }else{
        return "not supoort"
    }

}

function Contacts(){

    const [access,set_access] = useState([])

    useEffect(()=>{
        checkProperties()
    },[])

    async function checkProperties() {
        let accessList = []
        if(!navigator.contacts)
            return false

        const supportedProperties = await navigator.contacts.getProperties();
        if (supportedProperties.includes('name')) {
            // run code for name support
            accessList.push("name")
        }
        if (supportedProperties.includes('email')) {
            // run code for email support
            accessList.push("email")
        }
        if (supportedProperties.includes('tel')) {
            // run code for telephone number support
            accessList.push("tel")
        }
        if (supportedProperties.includes('address')) {
            // run code for address support
            accessList.push("address")
        }
        if (supportedProperties.includes('icon')) {
            // run code for avatar support
            accessList.push("icon")
        }

        set_access(accessList)
    }

    // const props = ['name', 'email', 'tel', 'address', 'icon'];
    const opts = {multiple: false};

    const [con,set_con] = useState([])

    async function getContacts() {
        try {
            const contacts = await navigator.contacts.select(access, opts);
            console.log(contacts)
            set_con(contacts);

        } catch (ex) {
            console.log(ex)
            // Handle any errors here.
        }
    }


    return(
        <div>
            <h2>{checkContacts()}</h2>
            {access.map(m=>{
                return(
                    <span>{m}</span>
                )
            })}

            {con.map(c=>{
                return(
                    <span>{c.name}</span>
                )
            })}

            <h1 onClick={()=>{
                getContacts()
            }}>
                gettttttttttttt
            </h1>
        </div>
    )
}

export  {Contacts}
